export default [

     {
          path: '/business-continuity-setting',
          name: 'BusinessContinuitySetting',
          component: () => import("@/views/Page/BusinessContinuitySetting/BusinessContinuitySetting.vue"),
          meta: {
               title: 'Business Continuity Setting',
          },
     }
];